import { type FC } from "react";
import { LinkButton } from "../../../../../../common/components/Link";
import { useBooleanState } from "../../../../../../common/hooks/useBooleanState";
import { QuickEntryPopup } from "../../../../../../QuickEntryPopup/components/QuickEntryPopup";
import { QuickEntryPopup as QuickEntryPopupV2 } from "../../../../../../QuickEntryPopup/v2/QuickEntryPopup";
import { useTranslation } from "react-i18next";
import { userIsCustomer } from "~/utils/roles";
import { hasProductConfiguredPC } from "~/QuickEntryPopup/helpers";
import { type QuickEntryItem } from "~/QuickEntryPopup/models";
import { addProductsToCartAction } from "~/QuickEntryPopup/redux/quickEntryActions";
import { addMessage } from "~/redux/globalMessages/actions";
import { useDispatch } from "react-redux";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

interface BulkATCButtonProps {
  className?: string;
}

export const EnterDesignationBtn: FC<BulkATCButtonProps> = ({ className }) => {
  const { val, setTrue, setFalse } = useBooleanState(false);
  const { t } = useTranslation();

  const isB2C = !userIsCustomer(); // check this
  const dispatch = useDispatch();

  return (
    <>
      <LinkButton
        iconBefore={<AddOutlinedIcon />}
        onClick={setTrue}
        data-test-id={"btn-enter-designation"}
        className={className}
      >
        {t("cartPage.btn.designation")}
      </LinkButton>
      {val && !isB2C && <QuickEntryPopup onClose={setFalse} />}
      {val && isB2C && (
        <QuickEntryPopupV2
          variant={"b2c-cart"}
          onClose={setFalse}
          onAdd={async (form, setIsSending, onClose) => {
            const items = form.items?.filter(hasProductConfiguredPC) ?? [];
            const modifiedItems = items.map((item: QuickEntryItem) => {
              const filteredProductId = item.productId.replace(/-/g, "");
              const isMatNo = !!parseInt(filteredProductId) && filteredProductId.length == 15;

              return {
                ...item,
                productId: isMatNo ? filteredProductId : item.productId,
                packCode: isMatNo ? filteredProductId.substring(13, 15) : item.packCode,
              };
            });
            setIsSending(true);
            await dispatch(addProductsToCartAction(modifiedItems));
            setIsSending(false);
            if (items.length > 0) {
              dispatch(addMessage("info", t("addToCart.success", { count: items.length })));
            }
            onClose();
          }}
          addButtonLabel={t("addToCartPopup.add.submitBtn")}
        />
      )}
    </>
  );
};
